import { Injectable } from "@angular/core";
import type { TranslocoMissingHandler, TranslocoMissingHandlerData } from "@jsverse/transloco";

const DISPLAY_TEXT = /[\u0600-\u06FF]|\s/;

@Injectable()
export class AzmTranslocoMissingHandler implements TranslocoMissingHandler {
	handle(key: string, data: TranslocoMissingHandlerData): string {
		if (!key || DISPLAY_TEXT.test(key)) {
			return key;
		}

		if (!data.prodMode) {
		}

		return key;
	}
}
